import React from 'react';
import './Header.scss';

function Header() {
  return (
    <div className="header">
      <a
        href="https://labeling.cslbehring.com/PI/US/Hemgenix/EN/Hemgenix-Prescribing-Information.pdf"
        target="blank"
        className="link"
        rel="noreferrer"
      >
        Prescribing Information
      </a>
      <a
        href="https://www.hemgenix.com/hcp/important-safety-information"
        className="link"
        target="blank"
        rel="noreferrer"
      >
        Important Safety Information
      </a>
    </div>
  );
}

export default Header;
